import { Stack } from "types/generated";
import { useBulkEnableStack } from "shared/Stack/useEnableStack";
import useCanEnableStack from "shared/Stack/access/useCanEnableStack";

import { StackBulkActions } from "../types";
import { BULK_ACTION_NAMES, BULK_ACTION_RESULTS_TITLE } from "../constants";

const useEnableStackBulkAction = () => {
  const [enableStack] = useBulkEnableStack();

  const canEnableStack = useCanEnableStack();

  return {
    key: StackBulkActions.Enable,
    title: BULK_ACTION_NAMES[StackBulkActions.Enable],
    resultTitle: BULK_ACTION_RESULTS_TITLE[StackBulkActions.Enable],
    condition: (stack: Stack) => canEnableStack(stack),
    mutation: (stack: Stack) => enableStack({ id: stack.id }),
  };
};

export default useEnableStackBulkAction;
